// TeamSection.jsx
// (Optional but recommended in index.html for exact typography)
// <link rel="preconnect" href="https://fonts.googleapis.com" />
// <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
// <link href="https://fonts.googleapis.com/css2?family=Archivo:wght@700;800&family=DM+Sans:wght@400;500;600&display=swap" rel="stylesheet" />

import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import HVACimg from "../../../Assets/Card_HVAC.png"
import WATERimg from "../../../Assets/Card_Water.png"
import CLEANINGimg from "../../../Assets/Card_Cleaning.png"
import ROOFINGimg from "../../../Assets/Card_Roofing.png"

const team = [
  {
    name: "HVAC Solutions",
    role: "Comfort You Can Trust",
    img: HVACimg,
    variant: "blue",
  },
  {
    name: "Water Mitigation",
    role: "Fast Response. Lasting Protection.",
    img: WATERimg,
    variant: "orange",
  },
  {
    name: "Professional Cleaning",
    role: "Spotless Homes, Stress-Free Living",
    img: CLEANINGimg,
    variant: "yellow",
  },
  {
    name: "Roofing Services",
    role: "Strong Roofs. Strong Homes.",
    img: ROOFINGimg,
    variant: "purple",
  },
];

const TeamSection = () => {
  return (
    <>
      <style>{`
        :root {
          --team-accent: #7ac142;
          --team-bg: #f8fafc;
          --team-name: #111827;
          --team-role: #6b7280;
          --team-card-radius: 46px;
          --team-img-radius: 38px;
          --team-shadow: 0 30px 80px rgba(15, 23, 42, 0.08);
          --team-shadow-hover: 0 40px 100px rgba(15, 23, 42, 0.18);
          --team-font-heading: "Archivo", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
          --team-font-body: "DM Sans", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
          --team-anim-ease: cubic-bezier(0.16, 1, 0.3, 1);
        }

        .team-section {
          padding: 96px 16px 88px;
          background: #ffffff;
          display: flex;
          justify-content: center;
        }

        .team-inner {
          width: 100%;
          max-width: 1200px;
          margin: 0 auto;
        }

        /* Heading */
        .team-heading-wrap {
          text-align: center;
          margin-bottom: 48px;
        }

        .team-kicker-wrap {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 10px;
        }

        .team-kicker-line {
          width: 44px;
          height: 2px;
          border-radius: 999px;
          background: var(--team-accent);
        }

        .team-kicker {
          font-family: var(--team-font-body);
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: var(--team-accent);
        }

        .team-heading {
          font-family: var(--team-font-heading);
          font-weight: 800;
          font-size: 36px;
          line-height: 1.2;
          color: #111827;
          margin: 0;
        }

        /* Cards */
        .team-card {
          position: relative;
          border-radius: var(--team-card-radius);
          padding: 24px 26px 26px;
          background: linear-gradient(180deg, #f5f7fb 0%, #deefff 100%);
          box-shadow: var(--team-shadow);
          overflow: hidden;
          display: flex;
          flex-direction: column;
          align-items: center;
          transition:
            transform 260ms var(--team-anim-ease),
            box-shadow 260ms var(--team-anim-ease),
            background-position 260ms var(--team-anim-ease);
          background-size: 100% 130%;
          background-position: 50% 0%;
          text-align: center;
        }

        .team-card--orange {
          background: linear-gradient(180deg, #fff7ea 0%, #ffe2b8 100%);
          background-size: 100% 130%;
        }

        .team-card--yellow {
          background: linear-gradient(180deg, #f9ffe7 0%, #ebf8cb 100%);
          background-size: 100% 130%;
        }

        .team-card--purple {
          background: linear-gradient(180deg, #f8f1ff 0%, #eed7ff 100%);
          background-size: 100% 130%;
        }

        .team-card:hover {
          transform: translate3d(0, -10px, 0);
          box-shadow: var(--team-shadow-hover);
          background-position: 50% 14%;
        }

        .team-img-wrap {
          width: 100%;
          border-radius: var(--team-img-radius);
          overflow: hidden;
          position: relative;
          margin-bottom: 22px;
        }

        .team-img {
          display: block;
          width: 100%;
          height: 260px;
          object-fit: cover;
          transition: transform 260ms var(--team-anim-ease);
          transform-origin: center;
        }

        .team-card:hover .team-img {
          transform: scale(1.04) translate3d(0, -4px, 0);
        }

        .team-plus {
          position: absolute;
          top: 18px;
          right: 18px;
          width: 32px;
          height: 32px;
          border-radius: 999px;
          background-color: rgba(255, 255, 255, 0.9);
          border: 1px solid #e5e7f0;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          font-weight: 500;
          color: #111827;
          box-shadow: 0 10px 22px rgba(15, 23, 42, 0.15);
          transition:
            background-color 220ms var(--team-anim-ease),
            color 220ms var(--team-anim-ease),
            transform 220ms var(--team-anim-ease),
            box-shadow 220ms var(--team-anim-ease);
        }

        .team-card:hover .team-plus {
          background-color: var(--team-accent);
          color: #ffffff;
          transform: scale(1.06);
          box-shadow: 0 14px 26px rgba(122, 193, 66, 0.6);
        }

        .team-name {
          font-family: var(--team-font-heading);
          font-size: 18px;
          font-weight: 700;
          color: var(--team-name);
          margin-bottom: 4px;
        }

        .team-role {
          font-family: var(--team-font-body);
          font-size: 14px;
          color: var(--team-role);
        }

        /* Responsive */
        @media (max-width: 1199px) {
          .team-section {
            padding-top: 80px;
            padding-bottom: 72px;
          }
        }

        @media (max-width: 959px) {
          .team-heading {
            font-size: 32px;
          }
        }

        @media (max-width: 599px) {
          .team-section {
            padding-top: 64px;
            padding-bottom: 64px;
          }
          .team-heading {
            font-size: 26px;
          }
        }
      `}</style>

      {/* SECTION */}
      <Box component="section" className="team-section">
        <Box className="team-inner">
          
          {/* Heading */}
          <Box className="team-heading-wrap">
            <Box className="team-kicker-wrap">
              <Box className="team-kicker-line" />
              <Typography className="team-kicker">Our Services</Typography>
              <Box className="team-kicker-line" />
            </Box>
            <Typography component="h2" className="team-heading">
             Professional Solutions You Can Rely On
            </Typography>
          </Box>

          {/* Cards (Centered) */}
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            justifyContent="center"
            textAlign="center"
          >
            {team.map((person, idx) => (
              <Grid item xs={12} sm={6} md={3} key={person.name}>
                <Box
                  className={`team-card team-card--${person.variant}`}
                  aria-label={`${person.name}, ${person.role}`}
                >
                  <Box className="team-img-wrap">
                    <img src={person.img} alt={person.name} className="team-img" />

                    <button
                      type="button"
                      className="team-plus"
                      aria-label={`View details for ${person.name}`}
                    >
                      +
                    </button>
                  </Box>

                  <Typography className="team-name">{person.name}</Typography>
                  <Typography className="team-role">{person.role}</Typography>
                </Box>
              </Grid>
            ))}
          </Grid>

        </Box>
      </Box>
    </>
  );
};

export default TeamSection;
